import React from 'react';

export const AppSecLogo = ({style}: {style?: Record<string, any>}) => {
  return (
    <div>
      <img style={style} src='/pictures/AppSecLogo.svg' alt="AppSec Logo" />
    </div>
  );
};